import { useTranslation } from 'react-i18next';

import { ScCounter } from './styled';

interface CounterProps {
  spin: number;
  image?: string;
  translation: string;
  mainRadialGradient: string;
  spinBtnBg?: string;
}

export const Counter = ({
  spin,
  image,
  translation,
  mainRadialGradient,
  spinBtnBg,
}: CounterProps) => {
  const { t } = useTranslation(translation);

  return image ? (
    <div className="counter__image">
      <h1>
        {2 - spin} {t('spinsLeft')}
      </h1>
      <img alt="Counter" src={image} />
    </div>
  ) : (
    <ScCounter
      className="counter"
      mainRadialGradient={mainRadialGradient}
      spinBtnBg={spinBtnBg}
    >
      <span>
        {2 - spin} {t('spinsLeft')}
      </span>
    </ScCounter>
  );
};
